import { Version } from '@smals/ngx-version-control';

export const APP_VERSION: Version = {
  version: '3.1.10',
  timestamp: '17/03/2026 10:19:11'
};
